import React, { useRef, useState, useEffect } from "react";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  checkEmpty,
  dateParser
} from "services/utils/commonFunctions/CommonFunctions";
import Config from "services/config/config";
import ConstVar from "constants/const";
import { trim, uniq } from "lodash";
import CustomModal from "components/modal/modal";
import CopyPaste from "components/copypaste/Copypaste";
import { BaseUrl } from "context/baseUrl/baseUrl";
import FormSection from "components/form/FormSection";
import Loader from "components/loader/loader";
import MainLayout from "components/mainLayout/MainLayout";
import JsonFormatter from "react-json-formatter";
import DropdownFilter from "components/input/dropdown/dropDownFilter";

const ESign = ({ match }) => {
  const [isCheck, setIsCheck] = useState([]);
  const [smallModal, setSmallModal] = useState({hover1: false, hover2: false, show: false});
  const [modalShow, setModalShow] = useState(false);
  const [activeComponent, setActiveComponent] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [applicationCode, setApplicationCode] = useState("");
  const [response, setResponse] = useState(null);
  const [request, setRequest] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [breList, setBreList] = useState([]);
  const [applicationCodeList, setApplicationCodeList] = useState([
    { applicationCodeKey: "ADJ", applicationCodeName: "ADJ" },
    { applicationCodeKey: "DA", applicationCodeName: "DA" },
    { applicationCodeKey: "Fusion", applicationCodeName: "Fusion" },
  ]);
  const scrl = useRef(null);

  useEffect(()=>{
    (async () => {
    eSignApi(1);
   })();
  },[])

  const eSignApi = async (page, handleRecordPerPage) => {
    setisLoading(true);
    const data={
      pageSize: handleRecordPerPage ? handleRecordPerPage : perPageRecord,
      pageNo: page ? page : 1,
      searchName: applicationCode ? trim(applicationCode) : "",
    }

    const res = await callWebService(
      callTypes.post,
      data,
      Config.esignList
    );

    if (res?.data?.data?.e_sign_list) {
      setBreList(res?.data?.data?.e_sign_list);
      setPerPageRecord(res?.data?.data?.pagination?.pre_page_records);
      setTotalRecord(res?.data?.data?.pagination?.total_rows);
      setPageNo(page ? page : res?.data?.data?.pagination?.current_page);
      setisLoading(false);
    }
  }

  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "Application Code",
      "Application No",
      "Request/Response",
      "Http Status Code",
      "Error Code",
      "Error Message",
      "Created At",
      "Updated At"
    ];

    return headerElement.map((key, index) => {
      return <th key={index}>{key}</th>;
    });
  };

  const systemDateReqRes = (data) => {
    setModalShow(true);
    if (data?.request) {
      const req = trim(
        typeof data?.request === "object"
          ? JSON.stringify(data?.request)
          : data?.request
      );
      setRequest(req);
    }
    if (data?.response) {
      const res = trim(
        typeof data?.response === "object"
          ? JSON.stringify(data?.response)
          : data?.response
      );
      setResponse(res);
    }
  };

  const closeModal = () => {
    setModalShow(false);
    setResponse("");
    setRequest("");
  };

  const testJSON = (text) => {
    if (typeof text !== "string") {
      return false;
    }
    try {
      var json = JSON.parse(text);
      return json;
    } catch (error) {
      return false;
    }
  };

  const jsonStyle = {
    propertyStyle: { color: "red" },
    stringStyle: { color: "green" },
    numberStyle: { color: "darkorange" },
  };

  const recordsPerPage = [
    { records_id: 10, records_value: 10 },
    { records_id: 20, records_value: 20 },
    { records_id: 30, records_value: 30 },
    { records_id: 50, records_value: 50 },
  ];

  const renderBody = () => {  
   
    return (
      !checkEmpty(breList) &&
      breList.map((val, index) => {
        return (
          <tr key={index}>
            <td>{pageNo === 1 ? index + 1 : (pageNo - 1) * perPageRecord + index + 1 }</td>       
            <td>{val.system_code}</td>
            <td>{val.application_no}</td>
            <td>
              {" "}
              <a
                style={{ cursor: "pointer" }}
                className="anchorNew"
                onClick={() => systemDateReqRes(val)}
              >
                <u>Request / Response</u>
              </a>
            </td>
            <td>{val.http_status_code}</td>
            <td>{val.api_err_code}</td>
            <td>{val.api_error}</td> 
            <td>
              {val.created_at
                ? dateParser(
                  val.created_at,
                    `${ConstVar.DATE_FORMAT}`
                  )
                : null}
              <br />
              {val.created_at
                ? dateParser(
                  val.created_at,
                    `${ConstVar.TIME_FORMAT}`
                  )
                : null}
            </td>
            <td>
              {val.updated_at
                ? dateParser(
                  val.updated_at,
                    `${ConstVar.DATE_FORMAT}`
                  )
                : null}
              <br />
              {val.updated_at
                ? dateParser(
                  val.updated_at,
                    `${ConstVar.TIME_FORMAT}`
                  )
                : null}
            </td>          
          </tr>
        );
      })
    );
  };

  const nextPage = async (page) => {
    setisLoading(true);
    eSignApi(page);
    setisLoading(false);
  }

  const handleRecordsPerPage = async (event) => {
    setPageNo(1);
    setisLoading(true);
    eSignApi(1, parseInt(event.target.value));
  };

  const searchProductCode = () => {
    setPageNo(1);
    eSignApi(1);
  }

  const resetProductCode = () => {
    window.location.reload();
  }

  const handleApplicationCode = (e) => {
    const value = e.target.value;
    setApplicationCode(value);
  }

  const inputSearch = () => {
    return (
      <>
        <div style={{ display: "inline-block" }}>
          {/* <input
            type="text"
            className="search-button"
            onChange={(e) => setProductCode(e.target.value)}
            name="search"
            placeholder="Product Code"
            autoComplete="off"
            value={productCode?.trim()}
          /> */}
          <div className="dropdown1" style={{float: "none"}}>
          <DropdownFilter
            value={applicationCode}
            name="applicationCode"
            optionList={applicationCodeList}
            optIdKey="applicationCodeKey"
            optValueKey="applicationCodeName"
            id="applicationCode"
            placeholder="Application Code"
            onChange={handleApplicationCode}
          />
          </div>
          &nbsp;<button className="btn btn-primary" onClick={()=> searchProductCode()}>Search</button>
          &nbsp;
          <button
            className="btn btn-warning"
            onClick={()=> resetProductCode()}
          >
            Reset
          </button>
        </div>
        <div style={{ float: "right", position: "relative" }}>
          {breList && breList.length > 0 ? (
            <b
              className="pagination-value"
              data-hovered={smallModal.hover1}
              style={{ cursor: "pointer" }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover1: false, hover2: false });
              }}
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover1: true, show: true });
              }}
            >
              {pageNo == 1 ? pageNo : (pageNo - 1) * perPageRecord + 1}-
              {pageNo * perPageRecord > totalRecord
                ? totalRecord
                : pageNo * perPageRecord}{" "}
              of {totalRecord}
            </b>
          ) : (
            <span className="pagination-value">0 - 0 of 0</span>
          )}
          &nbsp;
          {smallModal.hover1 && (
            <div
              className="small-modal"
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover2: true });
              }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover2: false, hover1: false });
              }}
            >
              <span
                className="small-modal-option"
                data-disabled={pageNo === 1 && true}
                onClick={() => {
                  nextPage(1);
                }}
              >
                Newest
              </span>
              <span
                className="small-modal-option"
                data-disabled={totalRecord <= pageNo * perPageRecord && true}
                onClick={() => {
                  nextPage(Math.ceil(totalRecord / perPageRecord));
                }}
              >
                Oldest
              </span>
            </div>
          )}
          <button
            className="pagination-button"
            onClick={() => nextPage(pageNo - 1)}
            title="Newer"
            data-disabled={pageNo <= 1 && true}
            disabled={pageNo <= 1}
          >
            {"<"}
          </button>
          &nbsp;
          <button
            className="pagination-button"
            onClick={() => nextPage(pageNo + 1)}
            title="Older"
            data-disabled={
              totalRecord <= pageNo * perPageRecord || breList.length === 0
            }
            disabled={
              totalRecord <= pageNo * perPageRecord || breList.length === 0
            }
          >
            {">"}
          </button>
        </div>
        &nbsp;&nbsp;
      </>
    );
  };
  const filterSearch = () => {};

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout activeComponent={activeComponent} match={match}>
        <Layout
          title="E Sign List"
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
          <FormSection
            search={true}
            inputSearch={inputSearch}
            filterSearch={filterSearch}
            sortBy={() => {}}
            isCheck={isCheck}
          >
            <div
              className="panel-card-table"
              ref={scrl}
              style={{ width: "100%", overflow: "auto" }}
            >
              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}</tr>
                </thead>
                <tbody>{renderBody()}</tbody>
              </table>
            </div>
            <div style={{maxWidth: '150px'}}>
              <DropdownFilter o
                  ptIdKey="records_id"
                  optValueKey="records_value"
                  optionList={recordsPerPage}
                  placeholder="Records Per Page"
                  onChange={(event) => {
                    setPerPageRecord(event.target.value);
                    handleRecordsPerPage(event);
                  }}
                  value={perPageRecord}
               />
            </div>
          </FormSection>
          {modalShow && (
            <CustomModal
              show={modalShow}
              modalClose={closeModal}
              showHeader
              backdrop
            >
              <div className="modal-body chekdisplay">
                <div
                  className={
                    response !== "notification"
                      ? "panel-card panelcard"
                      : "panel-card"
                  }
                >
                  <div className="panel-heading pop">
                    {response !== "notification" ? (
                      <>
                        Request
                        <div style={{ float: "right" }}>
                          <CopyPaste data={request} />
                        </div>
                      </>
                    ) : (
                      "Notification Content"
                    )}
                  </div>
                  <div className="panel-body  mx-0 pop ">
                    <div className="panel-card-table ">
                      <div className="popupclass">
                        {testJSON(
                          request
                            ? request.toString().replace(/\\/g, "")
                            : "null"
                        ) ? (
                          <JsonFormatter
                            json={
                              request
                                ? request.toString().replace(/\\/g, "")
                                : "null"
                            }
                            tabWith={4}
                            jsonStyle={jsonStyle}
                          />
                        ) : request ? (
                          request.toString().replace(/\\/g, "")
                        ) : (
                          "null"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {response !== "notification" ? (
                  <div className="panel-card panelcard">
                    <div className="panel-heading pop">
                      Response
                      <div style={{ float: "right" }}>
                        <CopyPaste data={response} />
                      </div>
                    </div>
                    <div className="panel-body mx-0 pop ">
                      <div className="panel-card-table">
                        <div className="popupclass">
                          {testJSON(
                            response
                              ? response.toString().replace(/\\/g, "")
                              : "null"
                          ) ? (
                            <JsonFormatter
                              json={
                                response
                                  ? response.toString().replace(/\\/g, "")
                                  : "null"
                              }
                              tabWith={4}
                              jsonStyle={jsonStyle}
                            />
                          ) : response ? (
                            response.toString().replace(/\\/g, "")
                          ) : (
                            "null"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </CustomModal>
          )}
          <Loader isLoading={isLoading} />
        </Layout>
        <div className="mobile-view container">
          <h3>{localization.label.myLead}</h3>
          <div className="my-lead-wrap">
            {/* {!checkEmpty(dataList) &&
              dataList.map((data, index) => (
                <ApplicationBox data={data} key={index} history={history} />
              ))} */}
          </div>
        </div>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default ESign;
